





































import { Component, Vue, Prop } from 'vue-property-decorator'
import FormattedDate from '../../formatted-date/formatted-date.vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import { setNotificationsRead } from '@/store/notifications/reducer'
import { pushAnalyticsEvent } from '@/services/utils'
import { EventDetail } from '@/config/interface'

@Component({
  name: 'notifications-list-item',
  components: {
    FormattedDate,
  },
  directives: {
    ObserveVisibility,
  },
})
export default class NotificationsListItemComponent extends Vue {
  @Prop() headline!: string
  @Prop() content!: string
  @Prop() createdAt!: string
  @Prop() read!: boolean
  @Prop() notificationKey!: string
  @Prop() link!: string
  @Prop() lastChild!: boolean
  timeout!: ReturnType<typeof setTimeout>

  visibilityChanged(isVisible: boolean): void {
    if (isVisible && !this.read) {
      this.timeout = setTimeout(this.markAsRead, 4000)
    }
  }

  markAsRead(): void {
    setNotificationsRead({ notificationKeys: [this.notificationKey] })
  }

  getTarget(link: string): string {
    const isRelativePath = !/(http(s?)):\/\//i.test(link)
    if (isRelativePath) {
      return '_top'
    }

    const url = new URL(link)
    if (window.location.hostname === url.hostname) {
      return '_top'
    } else {
      return '_blank'
    }
  }

  sendAnalytics(): void {
    if (!this.link) return
    const event: EventDetail = {
      category: 'link',
      action: 'header.notifications_&_messages',
      label: 'notification',
      URL: this.link,
    }
    pushAnalyticsEvent(event)
  }

  beforeDestroy(): void {
    clearTimeout(this.timeout)
  }
}
